import html5 from "../../assets/technologies/html.svg";
import css3 from "../../assets/technologies/css.svg";
import javascript from "../../assets/technologies/javascript.svg";
import reactjs from "../../assets/technologies/java.webp";
import styledComponents from "../../assets/technologies/styled-components.svg";
import tailwindcss from "../../assets/technologies/tailwindcss.png";
import bootstrap from "../../assets/technologies/bootstrap.svg";
import sass from "../../assets/technologies/sass.png";
import npm from "../../assets/technologies/npm.png";
import laravel from "../../assets/technologies/laravel.svg";
import git from "../../assets/technologies/git.svg";
import github from "../../assets/technologies/github.svg";
import figma from "../../assets/technologies/figma.svg";
import adobexd from "../../assets/technologies/adobexd.svg";
import vscode from "../../assets/technologies/visual-studio-code.svg";
import {SiMongodb,SiRedis} from "react-icons/si";
import {FcLinux} from "react-icons/fc";
import Mongo from "../../assets/technologies/Mongolmg.png";
import Redis from "../../assets/technologies/redis.png";
import Redux from "../../assets/technologies/redux.png";
import Linux from "../../assets/technologies/linux.jpg";

export const iconsData = [
  {
    id: 1,
    icon: reactjs,
    name: "Java",
    href:"https://www.java.com/en/"
  },
  
  {
    id: 2,
    icon: css3,
    name: "CSS3",
    href: "https://www.w3schools.com/css/"
  },
  {
    id: 3,
    icon: javascript,
    name: "JavaScript",
    href:"https://developer.mozilla.org/en-US/docs/Web/JavaScript"
  },
  {
    id: 5,
    icon: html5,
    name: "HTML5",
    href: "https://www.w3.org/html/"
  },
  {
    id: 6,
    icon: Redux,
    name: "MySQL",
    href: "https://www.mysql.com/"
  },
  {
    id: 7,
    icon: Mongo,
    name: "Spring",
    href: "https://spring.io/"
  },
  {
    id: 8,
    icon: Redis,
    name: "AWS",
    href: "https://aws.amazon.com/free/?trk=14a4002d-4936-4343-8211-b5a150ca592b&sc_channel=ps&sc_campaign=acquisition&sc_medium=ACQ-P|PS-GO|Brand|Desktop|SU|Core-Main|Core|IN|EN|Text&s_kwcid=AL!4422!3!453325184782!e!!g!!aws&ef_id=Cj0KCQjwma6TBhDIARIsAOKuANziqLO45l-1n4StjAalnKASsgxWEg4jKBPaYMsmrN4v3m4j-m2wlMgaAkh7EALw_wcB:G:s&s_kwcid=AL!4422!3!453325184782!e!!g!!aws"
  },
  {
    id: 9,
    icon: Linux,
    name: "Linux",
    href: "https://www.linux.org/"
  },
  {
    id: 10,
    icon: sass,
    name: "JPA with Hibernate",
    href: "https://hibernate.org/"
  },

  {
    id: 11,
    icon: tailwindcss,
    name: "JDBC",
    href: "https://docs.oracle.com/javase/tutorial/jdbc/basics/index.html"
  },
  {
    id: 12,
    icon: npm,
    name: "IntelliJ Idea",
    href: "https://www.jetbrains.com/idea/"
  },
  {
    id: 13,
    icon: git,
    name: "Git",
    href: "https://git-scm.com/"
  },
  {
    id: 14,
    icon: github,
    name: "GitHub",
    href: "https://github.com/"
  },
  {
    id: 15,
    icon: vscode,
    name: "Visual Studio Code",
    href: "https://code.visualstudio.com/"
  },
];
